import { editNickName, getUserInfo, setAvatar, upload } from "@/apis/user";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { useUserInfoStore } from "@/stores/userInfo";
import { UploadAvatarParams } from "@/types/Api/User/Avatar";
import { Form, ImageUploadItem, Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";

export const useLogic = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { logout } = useUserAuthContext();
  const [userInfo, setUserInfo] = useUserInfoStore()((state) => [
    state.userInfo,
    state.setUserInfo,
  ]);
  const fetchUserInfo = async () => {
    const response = await getUserInfo({});
    if (response.ok) {
      // TODO: 请求失败的处理
      // 重新请求用户信息
      setUserInfo(response.data);
    } else {
      // TODO: 请求失败的处理
      logout();
    }
  };

  const onUpload = async (file: File): Promise<ImageUploadItem> => {
    const formData = new FormData();
    formData.append("imgFile", file);
    formData.append("type", "avatar");
    
    const result = await upload(formData);
    if (result.ok) {
      form.setFieldsValue({
        avatar: result.data.name,
      });
      return {
        url: result.data.name,
      };
    }else{
      return {
        url: '',
      };
    }
  };
  const saveData = async () => {
    const values = form.getFieldsValue();
    if (!values.avatar) {
      return Toast.show("请选择头像！");
    }

    if (!values.nickname) {
      return Toast.show("请填写昵称！");
    }
    const allPromise: Promise<any>[] = [];
    if (values.avatar !== userInfo.avatar) {
      allPromise.push(setAvatar({ avatarAddr: values.avatar }));
    }
    if (values.nickname !== userInfo.nickname) {
      allPromise.push(editNickName({ nickname: values.nickname }));
    }
    if (allPromise.length === 0) {
      return Toast.show("请更换头像或修改昵称！");
    }
    const result = await Promise.all(allPromise);
    const item = result.find((result) => !result.ok);
    if (item) {
      return Toast.show(item.msg);
    } else {
      Toast.show("保存成功");
      setUserInfo({
        avatar: values.avatar,
        nickname: values.nickname,
      });
      navigate(-1);
    }
  };

  return {
    form,
    userInfo,
    fetchUserInfo,
    onUpload,
    saveData,
  };
};
